import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const SuccessRes = ({ lang, res, onHide, dataTranslate }) => {
  const data =
    res.type === "add"
      ? dataTranslate.popups.add_client.res_message.add
      : dataTranslate.popups.add_client.res_message.update;
  return (
    <>
      <Modal.Header className="d-flex align-items-center justify-content-center "></Modal.Header>

      <Modal.Body className="mx-5 ">
        <div
          className="d-flex flex-column align-items-center gap-3 "
          dir={lang === "AR" ? "rtl" : ""}
        >
          <div className="d-flex flex-column d-flex flex-column align-items-center gap-1">
            <h1>{data.phone_number}</h1>
            <span className="p-3 h3" style={{ color: "#e65857" }}>
              {res.data.phoneNumber}
            </span>
          </div>

          <div className="d-flex flex-column d-flex flex-column align-items-center gap-1">
            <h1>{data.customer_code}</h1>
            <span className="p-3 h3" style={{ color: "#e65857" }}>
              {res.data.customer_code}
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        className="w-100 d-flex flex-row align-items-center"
        dir="ltr"
      >
        <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
          <Button onClick={onHide} style={{ backgroundColor: "#e65857" }}>
            {dataTranslate.popups.add_client.close}
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default SuccessRes;
